import type { Gravedad } from '../../api/ops/entregas';
import type { NombreIcono } from '../../componentes/iconos';
import type { Tono } from '../../marco/avisosCampana';
import type { TarjetaAyuda } from '../../marco/cabecera';

/** Textos de «Avisos» (5.1 y 5.2), los de la exportación de `diseno/entregas/`. */
export const TONO: Readonly<Record<Gravedad, Tono>> = { critical: 'rojo', warning: 'aviso', info: 'info' };
export const ICONO_GRAVEDAD: Readonly<Record<Gravedad, NombreIcono>> = { critical: 'triangle-alert', warning: 'circle-alert', info: 'info' };
export const COLOR_PUNTO: Readonly<Record<Gravedad, string>> = { critical: 'var(--rv-red)', warning: 'var(--rv-warning)', info: 'var(--rv-fg-3)' };

export const AYUDA_TUS_AVISOS: readonly TarjetaAyuda[] = [
    { icono: 'bell', titulo: 'Lo que te llega a ti', texto: 'Cada aviso llega a los roles que elige el negocio en «Quién recibe avisos». Lo que leas o archives es solo tuyo.' },
    { icono: 'triangle-alert', titulo: 'Rojo, amarillo o gris', texto: 'Rojo es crítico (también por email al propietario y no se silencia), amarillo es algo pendiente y gris, información.' },
    { icono: 'circle-check', titulo: 'Se quitan solos', texto: 'Cuando se resuelve lo que avisaba, el aviso pasa a «Resueltos».' },
];

export const AYUDA_QUIEN_RECIBE: readonly TarjetaAyuda[] = [
    { icono: 'users', titulo: 'Por rol', texto: 'Elige qué avisos recibe cada rol. Vale para los avisos que lleguen desde ahora.' },
    { icono: 'lock', titulo: 'Los críticos, siempre al propietario', texto: 'Un canal caído, una cuenta de cobro restringida o una disputa llegan siempre al propietario.' },
    { icono: 'user-check', titulo: 'Nunca sin nadie', texto: 'Cada aviso llega al menos a un rol.' },
];
